import axios from 'axios';
import { MATH_API } from '../report/mathReportApi';
import type { MathPeriod } from '../report/mathReportApi';

/** Запись мат. отчета с непроверенным изменением (сервер отдает всю строку, экрану нужны эти поля) */
export interface MathChange {
  id: number;
  pharmacyNum: string;
}

/** Непроверенные изменения за месяц в зоне видимости роли */
export async function fetchMathChanges(period: MathPeriod): Promise<MathChange[]> {
  const res = await axios.get<MathChange[]>(`${MATH_API}/changes`, { params: period });
  const list = Array.isArray(res.data) ? res.data : [];
  return list.map((item) => ({ id: item.id, pharmacyNum: String(item.pharmacyNum) }));
}

/** Снимает пометку изменения с одной записи */
export async function markMathChecked(id: number): Promise<void> {
  await axios.post(`${MATH_API}/changes/mark-checked`, { id });
}

/** Снимает пометки изменений со всех записей месяца в зоне видимости роли */
export async function markAllMathChecked(period: MathPeriod): Promise<void> {
  await axios.post(`${MATH_API}/changes/mark-all`, period);
}
